// 开发环境域名
// const host_development = 'https://fqjczclzwll.saasdiy.com' // admin/Fqrj111213
const host_development = 'https://nsaas.shopape.cn'
// admin Fqrj111213

export default {
    // 版本
    version: "3.1.0",
    baseURL: process.env.NODE_ENV == "production" ? "" : host_development,
    tencentMapKey: "FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW",
    psdKey: "FQ-POD-112233"
};
